export default __webpack_public_path__ + "static/uipath-latest-logo-new-ab87c92d2cf8df4a761ce73467d98e60.svg";